import React, { useState, useEffect, useReducer, useMemo } from 'react'
import axios from 'axios'
import List from './list'

const cashInHand = props => {
  const [particularName, setParticularName] = useState('');
  const [amount, setAmount] = useState('');

  const cashInHandListReducer = (state, action) => {
    switch (action.type) {
      case 'ADD':
        return state.concat(action.payload);
      case 'SET':
        return action.payload;
      case'REMOVE':
        return state.filter((todo) => todo.id !== action.payload);
      default:
          return state;
    }
  }
  
  const [cashInHandList, dispatch] = useReducer(cashInHandListReducer, [])

  useEffect(() => {
    axios
      .get('https://reacthookstodoapp.firebaseio.com/cash_in_hand.json')
      .then(result => {
        // console.log(result);
        const data = result.data;
        const lists = [];
        for (const key in data) {
          lists.push({id: key, name: data[key].name, amount: data[key].amount})
        }
        dispatch({ type: 'SET', payload: lists })
      })
      .catch(err =>{
        console.log(err);
      })
      return () => {
        
      }
  }, []);

  const inputChangeHandler = event => {
    setParticularName(event.target.value)
  }
  const amountChangeHandler = event => {
    setAmount(event.target.value)
  }

  const todoAddHandler = () => {
    if (!particularName || !amount) {
      return false;
    }
    axios
      .post('https://reacthookstodoapp.firebaseio.com/cash_in_hand.json', {name: particularName, amount: amount})
      .then(res => {
        const item = {id: res.data.name, name: particularName, amount: amount};
        dispatch({ type: 'ADD', payload: item })
        setParticularName('')
        setAmount('')
        console.log('count', props.count)
        props.setCount(props.count + 1)
      })
      .catch(err =>{
        console.log(err);
      })
  }

  const todoRemoveHandler = todoId => {
    axios
      .delete(`https://reacthookstodoapp.firebaseio.com/cash_in_hand/${todoId}.json`, {name: particularName})
      .then(res => {
        dispatch({ type: 'REMOVE', payload: todoId })
        console.log('count', props.count)
        props.setCount(props.count + 2)
      })
      .catch(err =>{
        console.log(err);
      })
    
  }

  return (
    <React.Fragment>
      <div style={{marginTop: '5px',  padding: '5px' }}>
        <h3 style={{textAlign: 'center',color: '#2e8bcc'}}><span style={{borderBottom: '2px solid #2e8bcc'}}>CASH IN HAND</span></h3>
        <input 
            type="text"
            placeholder="Particular"
            onChange={inputChangeHandler}
            value={particularName}
            style={{height: '24px', marginRight: '2px'}}
          />
        <input 
            type="text"
            placeholder="Amount"
            onChange={amountChangeHandler}
            value={amount}
            style={{height: '24px'}}
          />
          <button type="button" onClick={todoAddHandler} className="btn btn-success">Add</button>
          <br />
          
          { useMemo(
              () => (
                cashInHandList.length > 0 ? <List items={cashInHandList} onClick={todoRemoveHandler} /> : <p className="none">None</p>
              ),
              [cashInHandList]
            )
          }
      </div>
    </React.Fragment>
  )
 
}

export default cashInHand;


// WEBPACK FOOTER //
// ./src/components/CashInHand/index.js